import { createApiAction } from '../../api/createApiAction';
import { LoginData, UserState } from '../slices/userSlice';

export const signIn = createApiAction<UserState, null, LoginData>(
  'user/login',
  '/auth/authenticate',
  'logIn'
);

export const register = createApiAction<UserState, null, LoginData>(
  'user/register',
  '/auth/register',
  'logIn'
);
